<template>
  <div v-if="error" class="error-container">
    <alert-circle-icon class="spacing" />
    <span>{{ translatedError }}</span>
  </div>
</template>

<script>
import AlertCircleIcon from '~/components/icons/AlertCircleIcon'

export default {
  name: 'DxGlobalErrorMessageAdapter',
  components: { AlertCircleIcon },
  props: {
    error: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    translatedError() {
      return this.error
        ? this.$t(`errors.${this.error.type}`, { ...this.error.params })
        : null
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/variables/colors';
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/variables/typo';

.error-container {
  display: flex;
  margin-top: rem(8);
  align-items: center;
  color: $functional-clr-error-dk;
  font-family: $font-family-heavy;
  font-size: rem($font-size-small);
  line-height: rem($font-line-height-xtra-small);

  @include media-breakpoint-up(lg) {
    font-size: rem($font-size);
    line-height: rem($font-line-height-small);
  }
}

.spacing {
  margin-right: rem(8);
}
</style>
